import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const InputContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 4px;
  margin: 8px auto;
`;

const InputLabel = styled.label`
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 11px;
  display: inline-block;
`;

const InputFieldContainer = styled.div`
  width: 100%;
  padding: 8px;
  border: 2px solid #DBDEE2;
  border-radius: 4px;
`;

const InputField = styled.input`
  width: 100%;
  border: none;
  outline-width: 0;
`;

const TextInput = ({
  className,
  label,
  placeholder,
  onChange,
  onKeyPress,
}) => (
  <InputContainer className={className}>
    <InputLabel>
      {label}
    </InputLabel>
    <InputFieldContainer>
      <InputField
        placeholder={placeholder}
        onChange={({ target }) => onChange(target)}
        onKeyUp={onKeyPress}
      />
    </InputFieldContainer>
  </InputContainer>
);

TextInput.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
};

TextInput.defaultProps = {
  className: '',
  label: '',
  placeholder: '',
  onChange: () => {},
  onKeyPress: () => {},
};

export default TextInput;
